


























































































import Vue from "vue";
import axios from "axios";
import InputForm from "./InputForm.vue";
import ItemTable from "./ItemTable.vue";
import {
  sortedDataAttributes,
  DataAttribute,
  getConfiguration,
  getConfigurationAsDataItems,
  DataItem
} from "@/model/DataViewConfigurationHelper";

import { detect as detectEncoding } from "chardet";

export default Vue.extend({
  name: "DataView",

  props: {
    routeName: {
      type: String,
      required: true
    }
  },

  components: { InputForm, ItemTable },

  data: () => ({
    items: [] as DataItem[],
    inputDialog: false,
    bulkImportDialog: false,
    importProgress: false,
    confirmDeleteDialog: false,
    confirmDeleteDialogItemId: "",
    loading: false,
    itemToEdit: null as DataItem | null,
    config: null as any,
    dataAttributes: [] as DataAttribute[],
    databaseCollection: "",
    editMeta: false
  }),

  computed: {
    listUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/${this.databaseCollection}/list`;
    },
    saveUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/${this.databaseCollection}/update`;
    },
    deleteUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/${this.databaseCollection}/delete`;
    },
    unsetUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/${this.databaseCollection}/unset`;
    },
    bulkImportUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/${this.databaseCollection}/bulkimport`;
    },
    showSwitchMetaEditButton(): boolean {
      return this.routeName !== "admin" && this.isAdmin;
    },
    configAttributes(): any {
      return this.config?.attributes ?? null;
    }
  },

  mounted() {
    this.loadData();
  },

  watch: {
    "$root.$data.user"() {
      this.loadData();
    }
  },

  methods: {
    async switchMetaEditMode() {
      this.editMeta = !this.editMeta;
      await this.loadData();
    },
    buildUpdatePayload(
      item: DataItem,
      selectorAttributes: any = undefined
    ): any {
      const result: any = {};
      const selector: any = {};
      const idKeySplit = item.id?.split("---") ?? [undefined];
      const id = idKeySplit[0];
      selector.id = id;
      selector.attributes = selectorAttributes;

      let updatedAttributes: any = {};
      if (this.editMeta) {
        if (!selector.id) {
          // always need the config-ID for metainfos
          selector.id = this.config?.id;
        }
        const key = idKeySplit[1]
          ? idKeySplit[1]
          : "attributes." + item.attributes["valueField"];
        for (const attrKey of Object.keys(item.attributes)) {
          const value = item.attributes[attrKey];
          const field =
            // payload.field.substring(0, payload.field.lastIndexOf(".")) +
            key +
            "." +
            attrKey.substring(attrKey.lastIndexOf("."), attrKey.length);
          updatedAttributes[field] = value;
        }
      } else {
        updatedAttributes = item.attributes;
      }

      result.selector = selector;
      result.attributes = updatedAttributes;

      return result;
      // field = field.replace("attributes.", "");
      // const split = id.split("---");
      // const itemId = split[0];
    },
    async saveItem(item: DataItem): Promise<void> {
      const payload = this.buildUpdatePayload(item);
      await axios.post(this.saveUrl, payload);
      this.displaySnack("Entry saved.");
      await this.loadData();
    },
    async updateProperty(payload: {
      itemId: string;
      field: string;
      value: any;
    }) {
      if (!payload || !payload.itemId || !payload.field || !payload.value) {
        return;
      }
      const fieldName = payload.field.startsWith("attributes.")
        ? payload.field.substring(11)
        : payload.field;
      const attributes = {
        [fieldName]: payload.value
      };
      await this.saveItem({ id: payload.itemId, attributes });
    },
    async loadData() {
      if (this.$auth.loggedIn && this.isObjectsReadAllowed) {
        this.loading = true;
        this.config = null;
        this.dataAttributes = [];
        this.databaseCollection = "";
        this.items = [];
        await this.loadConfiguration();
        await this.loadItems();
        this.loading = false;
      }
    },
    async loadConfiguration() {
      try {
        this.config = await getConfiguration(this.routeName);
        if (!this.config) {
          return;
        }
        Vue.set(this.$root.$data, "title", this.config.attributes.displayName);
        if (this.editMeta) {
          const metaConfig = (await getConfiguration("admin")).attributes;
          this.dataAttributes = sortedDataAttributes(
            metaConfig.fieldAttributes
          );
        } else {
          this.dataAttributes = sortedDataAttributes(
            this.configAttributes.attributes
          );
        }

        this.databaseCollection = this.editMeta
          ? "meta"
          : this.configAttributes.collection;
      } catch (e) {
        this.displaySnack("Refresh of attributes failed!", { color: "error" });
        console.error(e);
        this.dataAttributes = [];
        this.databaseCollection = "";
      }
    },
    async loadItems() {
      try {
        if (!this.editMeta) {
          const response = await axios.get(this.listUrl);
          this.items = response.data;
        } else {
          this.items = await getConfigurationAsDataItems(this.routeName);
        }
      } catch (e) {
        this.displaySnack("Reload failed!", { color: "error" });
        console.error(e);
        this.items = [];
      }
    },
    newItem() {
      this.itemToEdit = null;
      this.inputDialog = true;
    },
    gotoDetail(itemId: string) {
      const detailItem = this.items.find(item => item.id === itemId) || null;
      if (detailItem) {
        this.$router.push(this.routeName + "/" + itemId + "/detail");
      }
    },
    async editItem(itemId: string) {
      this.itemToEdit = this.items.find(item => item.id === itemId) || null;
      if (this.itemToEdit) {
        this.inputDialog = true;
      } else {
        this.displaySnack(`Entry with ID ${itemId} could not be found.`);
      }
    },
    askDeleteItem(itemId: string) {
      this.confirmDeleteDialog = true;
      this.confirmDeleteDialogItemId = itemId;
    },
    confirmDeleteItem() {
      this.confirmDeleteDialog = false;
      this.deleteItem(this.confirmDeleteDialogItemId);
      this.confirmDeleteDialogItemId = "";
    },
    abortDeleteItem() {
      this.confirmDeleteDialog = false;
      this.confirmDeleteDialogItemId = "";
    },
    async deleteItem(itemId: string) {
      if (this.editMeta) {
        const idKeySplit = itemId?.split("---") ?? [undefined];
        const requestUrl = `${this.unsetUrl}/${idKeySplit[0]}/${idKeySplit[1]}`;
        await axios.delete(requestUrl);
      } else {
        const requestUrl = `${this.deleteUrl}/${itemId}`;
        const response = await axios.delete(requestUrl);
        if (response.status === 200) {
          this.displaySnack(`Entry with ID ${itemId} was deleted.`, {
            color: "success"
          });
        } else if (response.status === 204) {
          this.displaySnack(`Entry mit ID ${itemId} could not be found.`, {
            color: "warning"
          });
        }
      }
      await this.loadData();
    },
    openBulkImportDialog() {
      this.bulkImportDialog = true;
    },
    resetBulkImport() {
      this.importProgress = false;
      (this.$refs.importInput as any).reset();
      this.bulkImportDialog = false;
    },
    async triggerBulkImport(file: File) {
      if (file) {
        console.log("Importing!");
        this.importProgress = true;

        const reader = new FileReader();
        reader.onloadend = async (event: ProgressEvent<FileReader>) => {
          if (event && event.target) {
            const buffer = event.target.result as ArrayBuffer;
            const encoding = detectEncoding(Buffer.from(buffer)) as string;
            if (!encoding) {
              this.displaySnack(
                "Encoding of file could not be determined, cancelling Import.",
                { color: "error" }
              );
              this.resetBulkImport();
              return;
            }
            console.log(encoding);
            const decoder = new TextDecoder(encoding);
            const text = decoder.decode(buffer);
            // console.log(text);
            await this.saveItem({
              attributes: {
                name: "Imported",
                content: text
              }
            });
          }
          this.resetBulkImport();
        };
        reader.onerror = this.resetBulkImport;

        reader.onabort = this.resetBulkImport;

        reader.readAsArrayBuffer(file);
      }
    },
    async triggerBulkImportCsv(file: File) {
      const formData = new FormData();
      formData.append("input_file", file);
      try {
        this.displaySnack(`Import started.`, { color: "primary" });
        this.bulkImportDialog = false;
        const response = await axios.post<DataItem[]>(
          this.bulkImportUrl,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        const importedItems = response.data.length;
        this.displaySnack(`${importedItems} entries were imported.`, {
          color: "success"
        });
        await this.loadData();
      } catch (e) {
        console.log("Bulk import failed!", e);
        this.displaySnack("Import failed!", { color: "error" });
      }
    },

    newDummyItem() {
      const plz = Math.floor(Math.random() * 90000 + 10000);
      const newItem: DataItem = {
        attributes: {
          kreis: `Kreis: ${plz}`,
          status: `${Math.floor(Math.random() * 5 + 1)}`,
          persons: `${Math.floor(Math.random() * 50 + 50)}`,
          postcode: `${plz}`,
          phone: `+49 228 9770-${Math.floor(Math.random() * 900 + 100)}`
        }
      };
      this.saveItem(newItem);
    }
  }
});
